import React from "react";
import styled from "styled-components";
import { mobileSize } from "../../util/variables";
import { FlexDiv } from "./FlexDiv";

interface StarProps {
  color?: string;
  width?: number;
  height?: number;
  mobileWidth?: number;
  mobileHeight?: number;
}

const StarFilled: React.FC<StarProps> = ({
  color = "currentColor",
  width = 21.25,
  height = 20,
  mobileWidth = 129,
  mobileHeight = 24,
}) => {
  return (
    <StarsSVG
      width={width}
      height={height}
      mobileWidth={mobileWidth}
      mobileHeight={mobileHeight}
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.92622 31.7286C7.23698 31.9698 7.58785 32.0503 7.97881 31.9698C8.36977 31.8995 8.79582 31.6984 9.25696 31.3666L17.2116 25.5005L25.1812 31.3666C25.6423 31.6984 26.0684 31.8995 26.4594 31.9698C26.8503 32.0503 27.2012 31.9698 27.5119 31.7286C27.8227 31.4973 28.0082 31.1857 28.0683 30.7936C28.1385 30.4015 28.0783 29.934 27.8879 29.3911L24.7451 20.0113L32.7749 14.2205C33.2461 13.8888 33.5719 13.547 33.7523 13.1951C33.9328 12.8432 33.9628 12.4813 33.8426 12.1093C33.7223 11.7474 33.4867 11.476 33.1358 11.295C32.7849 11.114 32.3188 11.0286 31.7374 11.0386L21.8881 11.099L18.8957 1.67389C18.7153 1.12095 18.4847 0.703739 18.204 0.422243C17.9333 0.140748 17.6025 0 17.2116 0C16.8306 0 16.4998 0.140748 16.2191 0.422243C15.9485 0.703739 15.7229 1.12095 15.5425 1.67389L12.5501 11.099L2.7008 11.0386C2.11937 11.0286 1.65322 11.114 1.30236 11.295C0.951492 11.476 0.715912 11.7474 0.595615 12.1093C0.475319 12.4813 0.505393 12.8432 0.685838 13.1951C0.866282 13.547 1.19209 13.8888 1.66325 14.2205L9.69304 20.0113L6.55029 29.3911C6.35982 29.934 6.29466 30.4015 6.35481 30.7936C6.42498 31.1857 6.61545 31.4973 6.92622 31.7286Z"
        fill={color}
      />
    </StarsSVG>
  );
};

const StarEmpty: React.FC<StarProps> = ({
  color = "currentColor",
  width = 21.25,
  height = 20,
  mobileWidth = 129,
  mobileHeight = 24,
}) => {
  return (
    <StarsSVG
      width={width}
      height={height}
      mobileWidth={mobileWidth}
      mobileHeight={mobileHeight}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.18945 21.6875C4.98763 21.5378 4.86393 21.3359 4.81836 21.082C4.7793 20.8281 4.82161 20.5254 4.94531 20.1738L6.98633 14.0996L1.77148 10.3496C1.46549 10.1348 1.25391 9.91341 1.13672 9.68555C1.01953 9.45768 1 9.22331 1.07812 8.98242C1.15625 8.74805 1.30924 8.57552 1.53711 8.46484C1.76497 8.34766 2.06771 8.28906 2.44531 8.28906H8.8418L10.7852 2.22461C10.9023 1.86654 11.0488 1.59635 11.2246 1.41406C11.4069 1.23177 11.6217 1.14062 11.8691 1.14062C12.123 1.14062 12.3379 1.23177 12.5137 1.41406C12.696 1.59635 12.8457 1.86654 12.9629 2.22461L14.9062 8.28906H21.3027C21.6803 8.28906 21.9831 8.34766 22.2109 8.46484C22.4388 8.57552 22.5918 8.74805 22.6699 8.98242C22.748 9.22331 22.7285 9.45768 22.6113 9.68555C22.4941 9.91341 22.2826 10.1348 21.9766 10.3496L16.7617 14.0996L18.8027 20.1738C18.9264 20.5254 18.9655 20.8281 18.9199 21.082C18.8809 21.3359 18.7604 21.5378 18.5586 21.6875C18.3568 21.8438 18.1289 21.8958 17.875 21.8438C17.6211 21.7982 17.3444 21.668 17.0449 21.4531L11.8691 17.6543L6.70312 21.4531C6.40365 21.668 6.12695 21.7982 5.87305 21.8438C5.61914 21.8958 5.39128 21.8438 5.18945 21.6875Z"
        stroke={color}
      />
    </StarsSVG>
  );
};

const StarHalf: React.FC<StarProps> = ({
  color = "currentColor",
  width = 21.25,
  height = 20,
  mobileWidth = 129,
  mobileHeight = 24,
}) => {
  return (
    <StarsSVG
      width={width}
      height={height}
      mobileWidth={mobileWidth}
      mobileHeight={mobileHeight}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.18945 21.6875C4.98763 21.5378 4.86393 21.3359 4.81836 21.082C4.7793 20.8281 4.82161 20.5254 4.94531 20.1738L6.98633 14.0996L1.77148 10.3496C1.46549 10.1348 1.25391 9.91341 1.13672 9.68555C1.01953 9.45768 1 9.22331 1.07812 8.98242C1.15625 8.74805 1.30924 8.57552 1.53711 8.46484C1.76497 8.34766 2.06771 8.28906 2.44531 8.28906H8.8418L10.7852 2.22461C10.9023 1.86654 11.0488 1.59635 11.2246 1.41406C11.4069 1.23177 11.6217 1.14062 11.8691 1.14062C12.123 1.14062 12.3379 1.23177 12.5137 1.41406C12.696 1.59635 12.8457 1.86654 12.9629 2.22461L14.9062 8.28906H21.3027C21.6803 8.28906 21.9831 8.34766 22.2109 8.46484C22.4388 8.57552 22.5918 8.74805 22.6699 8.98242C22.748 9.22331 22.7285 9.45768 22.6113 9.68555C22.4941 9.91341 22.2826 10.1348 21.9766 10.3496L16.7617 14.0996L18.8027 20.1738C18.9264 20.5254 18.9655 20.8281 18.9199 21.082C18.8809 21.3359 18.7604 21.5378 18.5586 21.6875C18.3568 21.8438 18.1289 21.8958 17.875 21.8438C17.6211 21.7982 17.3444 21.668 17.0449 21.4531L11.8691 17.6543L6.70312 21.4531C6.40365 21.668 6.12695 21.7982 5.87305 21.8438C5.61914 21.8958 5.39128 21.8438 5.18945 21.6875Z"
        stroke={color}
      />
      <path
        d="M12.369 1.14062C12.424 1.14063 12.478 1.14361 12.5311 1.14941V18.8936L12.368 18.7744L7.4989 22.3555L7.49402 22.3594C7.16194 22.5976 6.82009 22.7682 6.47253 22.833L6.47351 22.834C6.0825 22.9142 5.70897 22.8304 5.39148 22.5879V22.5889C5.39004 22.5878 5.38899 22.5861 5.38757 22.585C5.38647 22.5841 5.3848 22.5838 5.38367 22.583V22.582C5.08151 22.3547 4.89285 22.0421 4.82605 21.6699L4.8241 21.6582C4.76816 21.2946 4.83398 20.9044 4.97351 20.5078L6.89441 14.79L1.97937 11.2559V11.2549C1.63764 11.0142 1.35879 10.7378 1.19226 10.4141C1.01498 10.0693 0.982666 9.69736 1.10242 9.32812L1.10339 9.32422L1.15515 9.19141C1.2889 8.89141 1.51599 8.66147 1.81824 8.51465V8.51562C2.14043 8.35264 2.5271 8.28906 2.94519 8.28906H8.97644L10.8085 2.57227L10.8094 2.56934L10.9169 2.28125C11.0331 2.00371 11.1787 1.75981 11.3641 1.56738L11.371 1.56055L11.4764 1.46484C11.7288 1.25457 12.0313 1.14062 12.369 1.14062Z"
        fill={color}
      />
    </StarsSVG>
  );
};

interface FiveStarsProps {
  color?: string;
  width?: number;
  height?: number;
  mobileWidth?: number;
  mobileHeight?: number;
  numberOfStars?: number;
}
const FiveStars: React.FC<FiveStarsProps> = ({
  color = "currentColor",
  width = 21.25,
  height = 20,
  mobileWidth = 129,
  mobileHeight = 24,
  numberOfStars = 5, // NOTE: this current solution only works for half star increments
}) => {
  return (
    <FlexDiv gap={2}>
      {Array.from({ length: 5 }).map((_, i) => {
        const starValue = i + 1;
        if (starValue <= numberOfStars) {
          return (
            <StarFilled
              key={`star-${starValue}-filled`}
              color={color}
              width={width}
              height={height}
              mobileWidth={mobileWidth}
              mobileHeight={mobileHeight}
            />
          );
        }

        if (starValue - 0.5 <= numberOfStars) {
          return (
            <StarHalf
              key={`star-${starValue}-half`}
              color={color}
              width={width}
              height={height}
              mobileWidth={mobileWidth}
              mobileHeight={mobileHeight}
            />
          );
        }

        return (
          <StarEmpty
            key={`star-${starValue}-empty`}
            color={color}
            width={width}
            height={height}
            mobileWidth={mobileWidth}
            mobileHeight={mobileHeight}
          />
        );
      })}
    </FlexDiv>
  );
};

const StarsSVG = styled.svg<{ mobileWidth?: number; mobileHeight?: number }>`
  @media ${mobileSize} {
    width: ${({ mobileWidth }) => mobileWidth}px;
    height: ${({ mobileHeight }) => mobileHeight}px;
  }
  pointer-events: none;
`;

export default FiveStars;
